// extracted by mini-css-extract-plugin
export default {"root":"PerformersItem_root__LipwY","blockCircle":"PerformersItem_blockCircle__NaZ2V","circle":"PerformersItem_circle__Nmf3S"};